import SourceProductActions from 'SourceComponent/ProductActions/ProductActions.component';

import Field from 'Component/Field';
import isMobile from 'Util/Mobile';
import ProductReviewRating from 'Component/ProductReviewRating';
import ProductPrice from "Component/ProductPrice";
import TextPlaceholder from 'Component/TextPlaceholder';
import ProductDeliveryOptions from 'Component/ProductDeliveryOptions';
import ProductSpecs from 'Component/ProductSpecs';
import ProductPriceAlert from 'Component/ProductPriceAlert';
import Link from 'Component/Link';
import ProductAttributeValue from 'Component/ProductAttributeValue';
import AddToCart from 'Component/AddToCart';
import { GROUPED } from 'Util/Product';
import Popup from 'Component/Popup';
import ProductConfigurableAttributes
    from "Component/ProductConfigurableAttributes";
import * as Sentry from '@sentry/react';
import {isRoStore} from "Util/Store";
import CmsBlock from 'Component/CmsBlock';

function hasWebcam() {
    return new Promise((resolve, reject) => {
        if (!navigator || !navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
            reject('enumerateDevices() not supported.');
            return;
        }

        navigator.mediaDevices.enumerateDevices()
            .then(devices => {
                const hasCamera = devices.some(device => device.kind === 'videoinput');
                resolve(hasCamera);
            })
            .catch(err => {
                reject(err);
            });
    });
}

export class ProductActions extends SourceProductActions {

    state = {
        hasCamera: false,
        loading: true,
        DeepArComponent: null
    };

    componentDidMount() {
        hasWebcam()
            .then(hasCamera => {
                this.setState({
                    hasCamera: hasCamera,
                    loading: false,
                });
            })
            .catch(err => {
                Sentry.captureException(err);
                console.error(err);
                this.setState({ loading: false });
            });
    }

    renderNameAndBrand() {
        const { product: { name } } = this.props;

        return (
            <section
              block="ProductActions"
              elem="Section"
              mods={ { type: 'name' } }
            >
                <h1 block="ProductActions" elem="Title" itemProp="name">
                    <TextPlaceholder content={ name } length="medium" />
                </h1>
            </section>
        );
    }

    renderReviewStars() {

        const {
            product: {
                review_summary: {
                    review_count = 0,
                    rating_summary = 0,
                    four_and_five_star_percentage
                } = {}
            }
        } = this.props;

        if (!rating_summary) {
            return null;
        }

        const ONE_FIFTH_OF_A_HUNDRED = 20;
        const rating = parseFloat(rating_summary / ONE_FIFTH_OF_A_HUNDRED).toFixed(2);
        const reviewText = review_count === 1 ? __('review') : __('reviews');

        return (
            <section
                block="ProductActions"
                elem="Reviews"
            >
                <ProductReviewRating summary={rating_summary} reviews_count={review_count} />
                <span block="ProductActions" elem="Rating">
                    {rating}
                    <a className="review-counts" href="#product-review">{ `(${review_count} ${reviewText})` } </a>

                </span>
                <br/>
                {four_and_five_star_percentage > 80 && (
                    <a className="review-recomend" href="#product-review">
                        <span block="ProductActions" elem="Rating" style={{ fontSize: 16, margin: 5 }}>
                            <strong>{four_and_five_star_percentage}%</strong> {__('of clients are recommending this product')}
                        </span>
                        <br/>
                    </a>
                )}

            </section>
        );
    }


    renderReviews() {
        return null;
    }

    renderSkuAndStock() {
        if (!this.props.areDetailsLoaded) {
            return null;
        }
        const {
            product,
            product: { variants },
            product: { brand_url },
            product: { attributes: { gramaj, gama, override_brand_url } },
            configurableVariantIndex,
            showOnlyIfLoaded
        } = this.props;
        const productOrVariant = variants && variants[configurableVariantIndex] !== undefined
            ? variants[configurableVariantIndex]
            : product;

        const { sku, stock_status, salable_quantity_oos } = productOrVariant;

        var custom_brand_url = brand_url;

        if (override_brand_url &&  override_brand_url.attribute_value?.length > 0) {
            custom_brand_url = override_brand_url.attribute_value;
        }

        return (
            <section
              block="ProductActions"
              elem="Info"
            >
                { showOnlyIfLoaded(
                    sku,
                    (
                        <>
                            { gama && gama.attribute_value && (
                                <>
                                    <div block="ProductActions" elem="Brand" itemProp="brand" itemType="http://schema.org/Brand" itemScope>
                                        <meta itemProp="name" content={ gama.attribute_options[gama.attribute_value]?.label || '' }></meta>
                                        { brand_url
                                            ? <Link to={ `/${custom_brand_url}` }><ProductAttributeValue attribute={ gama } isFormattedAsText /></Link>
                                            : <ProductAttributeValue attribute={ gama } isFormattedAsText />}
                                    </div>
                                    <span block="ProductActions" elem="Info-Separator"></span>
                                </>
                            ) }
                            { sku && (
                                <div>{ __('Code:') }<span itemType="https://schema.org/Text" itemProp="sku" >{ sku }</span></div>
                            ) }
                            { gramaj && gramaj.attribute_value && (
                                <>
                                    <span block="ProductActions" elem="Info-Separator"></span>
                                    <ProductAttributeValue attribute={ gramaj } isFormattedAsText />
                                </>
                            ) }
                        </>
                    ),
                    <TextPlaceholder />
                ) }
            </section>
        );
    }

    renderPriceAlert() {
        const { productOrVariant: { id, type_id } = {} } = this.props;

        return <ProductPriceAlert product_id={ id } product_type={ type_id } />
    }

    renderProductDeliveryOptions() {
        const { product: { delivery_dates, stock_status, attributes, salable_quantity_oos } } = this.props;
        return (
            <ProductDeliveryOptions delivery_dates={ delivery_dates } stock_status={ stock_status } salable_quantity_oos={salable_quantity_oos} attributes={ attributes } />
        );
    }

    renderProductSpecs() {
        return (
            <ProductSpecs { ...this.props.product.attributes } />
        );
    }

    renderQuantityInput() {
        const {
            quantity,
            maxQuantity,
            minQuantity,
            setQuantity,
            product: { type_id, stock_status, salable_quantity_oos }
        } = this.props;

        if (
            type_id === GROUPED ||
            salable_quantity_oos
        ) {
            return null;
        }

        return (
            <Field
              id="item_qty"
              name="item_qty"
              type="number"
              value={ quantity || minQuantity }
              max={ maxQuantity }
              min={ minQuantity }
              mix={ { block: 'ProductActions', elem: 'Qty' } }
              onChange={ setQuantity }
            />
        );
    }

    renderAddToCart() {
        const {
            configurableVariantIndex,
            product,
            quantity,
            groupedProductQuantity,
            onProductValidationError,
            productOptionsData
        } = this.props;

        return (
            <AddToCart
              product={ product }
              configurableVariantIndex={ configurableVariantIndex }
              mix={ { block: 'ProductActions', elem: 'AddToCart' } }
              quantity={ quantity }
              groupedProductQuantity={ groupedProductQuantity }
              onProductValidationError={ onProductValidationError }
              productOptionsData={ productOptionsData }
              pdp={ true }
            />
        );
    }

    renderDeepArOverlay(deepArFilterData) {
        const {
            selectedSwatch
        } = this.props;

        const { DeepArComponent} = this.props;
        console.log('renderDeepArOverlay', this.props);

        return (
            <Popup
                id= 'DeepAr_Overlay_id'
                mix={ { block: 'ProductActions', elem: 'Popup' } }
            >
                <div className={"overlayDeepAr hidden"}></div>
                { DeepArComponent? <DeepArComponent filterData={ deepArFilterData } swatches={this.renderSwatches()} selectedSwatch={ selectedSwatch }></DeepArComponent>
                    : <span>No DeepAr component available.</span> }
            </Popup>
        );
    }

    renderDeepArButton() {
        const { showDeepArPopup } = this.props;

        return (
            <button
                mix={ { block: 'Button ProductActions', elem:'DeepArButton' } }
                onClick={ showDeepArPopup }
            >
                {__('New! Try the product on live!')}
            </button>
        );
    }

    renderPriceWithSchema() {
        const {
            productPrice,
            offerCount,
            cartRuleSpecialPrice
        } = this.props;

        return (
            <div>
                { this.renderSchema() }
                <ProductPrice
                    isSchemaRequired
                    variantsCount={ offerCount }
                    price={ productPrice }
                    cartRuleSpecialPrice = { cartRuleSpecialPrice }
                    mix={ { block: 'ProductActions', elem: 'Price' } }
                />
            </div>
        );
    }

    renderPriceWithGlobalSchema() {
        const {
            offerType,
            product: {
                type_id
            }
        } = this.props;

        if (type_id === GROUPED) {
            return null;
        }

        return (
            <div
                block="ProductActions"
                elem="Schema"
                itemType={ offerType }
                itemProp="offers"
                itemScope
            >
                { this.renderPriceWithSchema() }
            </div>
        );
    }

    renderSwatches() {
        const {
            getLink,
            parameters,
            areDetailsLoaded,
            product: { configurable_options, type_id },
            getIsConfigurableAttributeAvailable,
            updateConfigurableVariant,
            updateVariantInDeepAr
        } = this.props;

        if (type_id !== 'configurable') {
            return null;
        }

        return (
            <div
                ref={ this.configurableOptionsRef }
                block="ProductActions"
                elem="AttributesWrapper"
            >
                <ProductConfigurableAttributes
                    // eslint-disable-next-line no-magic-numbers
                    numberOfPlaceholders={ [2, 4] }
                    mix={ { block: 'ProductActions', elem: 'Attributes' } }
                    isReady={ areDetailsLoaded }
                    getLink={ getLink }
                    parameters={ parameters }
                    updateConfigurableVariant={ (attr_code, attr_val) => {updateVariantInDeepAr(attr_code, attr_val); updateConfigurableVariant(attr_code, attr_val);} }
                    configurable_options={ configurable_options }
                    getIsConfigurableAttributeAvailable={ getIsConfigurableAttributeAvailable }
                    isContentExpanded
                />
            </div>
        );
    }

    renderConfigurableAttributes() {
        const {
            getLink,
            updateConfigurableVariant,
            updateVariantInDeepAr,
            parameters,
            areDetailsLoaded,
            product: { configurable_options, type_id },
            getIsConfigurableAttributeAvailable
        } = this.props;

        if (type_id !== 'configurable') {
            return null;
        }

        return (
            <div
                ref={ this.configurableOptionsRef }
                block="ProductActions"
                elem="AttributesWrapper"
            >
                <ProductConfigurableAttributes
                    // eslint-disable-next-line no-magic-numbers
                    numberOfPlaceholders={ [2, 4] }
                    mix={ { block: 'ProductActions', elem: 'Attributes' } }
                    isReady={ areDetailsLoaded }
                    getLink={ getLink }
                    parameters={ parameters }
                    updateConfigurableVariant={ (attr_code, attr_val) => {updateVariantInDeepAr(attr_code, attr_val); updateConfigurableVariant(attr_code, attr_val);} }
                    configurable_options={ configurable_options }
                    getIsConfigurableAttributeAvailable={ getIsConfigurableAttributeAvailable }
                    isContentExpanded
                />
            </div>
        );
    }

    canRenderDeepAr() {
        const {
            deepArEnabled,
            product: {
                deepArFilter
            }
        } = this.props;
        const {hasCamera, loading: isComponentLoading} = this.state;

        return deepArEnabled && hasCamera && !isComponentLoading &&  deepArFilter?.length;
    }

    renderPointsEstimates() {
        const { cartRuleSpecialPrice, productPrice } = this.props;

        const crsp = cartRuleSpecialPrice?.price;
        const price = productPrice?.minimum_price?.final_price?.value;
        const priceForPoints = crsp ? crsp : (price || 0);
        const estimatedPoints = priceForPoints ? Math.floor(priceForPoints / 10) : null;

        return estimatedPoints !== null && (
            <span>{__('This product can earn you up to')} {estimatedPoints} {__('point(s)')}</span>
        );
    }

    calculatePointsEstimates() {
        const { cartRuleSpecialPrice, productPrice } = this.props;

        const crsp = cartRuleSpecialPrice?.price;
        const price = productPrice?.minimum_price?.final_price?.value;
        const priceForPoints = crsp ? crsp : (price || 0);
        const estimatedPoints = priceForPoints ? Math.floor(priceForPoints / 10) : null;

        return estimatedPoints;
    }

    renderCustomCmsBlock() {
        const pointsEstimates = this.calculatePointsEstimates();

        if (pointsEstimates === 0) {
            return null;
        }

        const doubledPoints = pointsEstimates * 2; // Double the points

        return (
            <div block="CmsBlock" elem="Custom">
                <CmsBlock
                    identifier="product_page_cms_message"
                    variables={{
                        estimatedPoints: pointsEstimates,
                        doubledPoints: doubledPoints
                    }}
                />
            </div>
        );
    }




    render() {
        const {
            DeepArComponent,
            deepArEnabled,
            areDetailsLoaded,
            product: {
                price_range: {
                    minimum_price: {
                        final_price: {
                            value
                        } = {}
                    } = {}
                } = {},
                deepArFilter
            }
        } = this.props;

        if (!areDetailsLoaded) {
            return null;
        }

        const onSale = this.renderPriceAlert();
        const onSaleWeb = !isMobile.any() ? onSale : null;
        const onSaleMobile = isMobile.any() ? onSale : null;
        const canRenderDeepAr = this.canRenderDeepAr();

        return (
            <article block="ProductActions">
                { this.renderNameAndBrand() }
                { this.renderSkuAndStock() }
                { this.renderReviewStars() }
                { this.renderConfigurableAttributes() }
                { isMobile.any() ? this.renderPriceWithGlobalSchema() : null}
                { isMobile.any() ? this.renderTierPrices() : null}
                { isMobile.any() ? this.renderCustomCmsBlock () : null}
                { onSaleMobile }
                { this.renderShortDescription() }
                { this.renderCustomizableOptions() }
                { this.renderBundleItems() }
                { this.renderGroupedItems() }
                { !isMobile.any() ? this.renderPriceWithGlobalSchema() : null}
                { !isMobile.any() ? this.renderTierPrices() : null}
                { !isMobile.any() ? this.renderCustomCmsBlock () : null}
                { !!value && <div block="ProductActions" elem="AddToCartWrapper">
                    { this.renderQuantityInput() }
                    { this.renderAddToCart() }
                    { this.renderProductWishlistButton() }
                    { canRenderDeepAr ? this.renderDeepArButton() : null }
                    { onSaleWeb }
                </div> }
                { this.renderProductDeliveryOptions() }
                { this.renderProductSpecs() }
                { DeepArComponent && canRenderDeepAr ? this.renderDeepArOverlay(deepArFilter) : null }
            </article>
        );
    }
}

export default ProductActions;
